import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/styles';

import ReactTicker from 'react-ticker';
import map from 'lodash/fp/map';

const styles = theme => ({
  root: {
    width: '100%',
    height: 64,
    margin: 0,
  },
  ticker: {
    width: '100%',
  },
  text: {
    ...theme.typography.mono1,
    color: '#6a7365',
    display: 'block',
    flexFlow: 'row',
    alignItems: 'center',
    height: 64,
    width: 'max-content',
    flexWrap: 'nowrap',
    margin: 0,
    lineHeight: '64px',
    textTransform: 'uppercase',
  },
});

const Ticker = ({ classes, content, showDash }) => {
  return (
    <div className={classNames(classes.root, 'remove-in-percy')}>
      <ReactTicker className={classes.ticker} direction="toLeft" move offset="1%" speed={7}>
        {() => (
          <p className={classes.text}>
            {map(
              entry =>
                showDash ? (
                  <span key={entry}>&nbsp;&nbsp;&nbsp;{entry}&nbsp;&nbsp;&nbsp;-</span>
                ) : (
                  <span key={entry}>{entry}&nbsp;&nbsp;&nbsp;</span>
                ),
              content
            )}
          </p>
        )}
      </ReactTicker>
    </div>
  );
};

Ticker.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  content: PropTypes.arrayOf(PropTypes.string).isRequired,
  showDash: PropTypes.bool,
};

Ticker.defaultProps = {
  showDash: true, // To be backward compatible
};

export default withStyles(styles)(Ticker);
